import axios from "axios";
import * as types from "./actionTypes";
import { useSelector } from "react-redux";
import { BASE_URL_PAYMENT } from "../App/action";

export let BASE_URL_EVENT;
export let BASE_URL_MEDIA;
export let BASE_URL_FLORAHUB;
export let BASE_URL_WISHLIST;
export let BASE_URL_USER;
export let BASE_URL_SEARCH;
export let BASE_URL_TEMPLATE;

if (process.env.NODE_ENV === "production") {
  BASE_URL_EVENT = process.env.REACT_APP_API_URL_EVENT;
  BASE_URL_MEDIA = process.env.REACT_APP_API_URL_MEDIA;
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
  BASE_URL_WISHLIST = process.env.REACT_APP_API_URL_WISHLIST;
  BASE_URL_USER = process.env.REACT_APP_API_URL_USER;
  BASE_URL_SEARCH = process.env.REACT_APP_API_URL_SEARCH;
  BASE_URL_TEMPLATE = process.env.REACT_APP_API_URL_TEMPLATE;
} else {
  BASE_URL_EVENT = process.env.REACT_APP_API_URL_EVENT;
  BASE_URL_MEDIA = process.env.REACT_APP_API_URL_MEDIA;
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
  BASE_URL_WISHLIST = process.env.REACT_APP_API_URL_WISHLIST;
  BASE_URL_USER = process.env.REACT_APP_API_URL_USER;
  BASE_URL_SEARCH = process.env.REACT_APP_API_URL_SEARCH;
  BASE_URL_TEMPLATE = process.env.REACT_APP_API_URL_TEMPLATE;
}
const accessToken = localStorage.getItem("token");
const orderIdFromLocal = localStorage.getItem("orderId");

// updateQuantity
const updateQuantity = (productId, variantId, quantity) => {
  return {
    type: "UPDATE_QUANTITY",
    payload: { productId, variantId, quantity },
  };
};
//updateCart
const updateCart = (newCartItems) => ({
  type: types.UPDATE_CART,
  payload: newCartItems,
});

// Suggested Prods
const getSuggestedProductsRequest = () => ({
  type: types.GET_SUGGESTED_PRODUCTS_REQUEST,
});

const getSuggestedProductsSuccess = (suggestedProducts) => ({
  type: types.GET_SUGGESTED_PRODUCTS_SUCCESS,
  payload: suggestedProducts,
});

const getSuggestedProductsError = (error) => ({
  type: types.GET_SUGGESTED_PRODUCTS_ERROR,
  payload: error,
});

//SingleProduct
const getSingleProductRequest = () => {
  return {
    type: types.GET_SINGLE_PRODUCT_REQUEST,
  };
};

const getSingleProductSuccess = (payload) => {
  return {
    type: types.GET_SINGLE_PRODUCT_SUCCESS,
    payload: payload,
  };
};

const getSingleProductError = () => {
  return {
    type: types.GET_SINGLE_PRODUCT_ERROR,
  };
};

//SimilarProduct
const getSimilarProductsRequest = () => ({
  type: types.GET_SIMILAR_PRODUCTS_REQUEST,
});

const getSimilarProductSuccess = (payload) => ({
  type: types.GET_SIMILAR_PRODUCTS_SUCCESS,
  payload: payload,
});

const getSimilarProductError = () => ({
  type: types.GET_SIMILAR_PRODUCTS_ERROR,
});

//Frequently Bought Together
const getFrequentlyBoughtTogetherRequest = () => ({
  type: types.GET_FREQUENTLY_BOUGHT_TOGETHER_REQUEST,
});

const getFrequentlyBoughtTogetherSuccess = (payload) => ({
  type: types.GET_FREQUENTLY_BOUGHT_TOGETHER_SUCCESS,
  payload: payload,
});

const getFrequentlyBoughtTogetherError = () => ({
  type: types.GET_FREQUENTLY_BOUGHT_TOGETHER_ERROR,
});

// AddToCart or CreateCart
const addToCartRequest = () => {
  return {
    type: types.ADD_TO_CART_REQUEST,
  };
};

const addToCartSuccess = (data) => {
  return {
    type: types.ADD_TO_CART_SUCCESS,
    payload: data,
  };
};

const addToCartError = (error) => {
  return {
    type: types.ADD_TO_CART_ERROR,
    error: error,
  };
};

//GetCART
const getCartRequest = () => {
  return {
    type: types.GET_CART_REQUEST,
  };
};
const getCartSuccess = (payload) => ({
  type: types.GET_CART_SUCCESS,
  payload: payload,
});

const getCartError = () => {
  return {
    type: types.GET_CART_ERROR,
  };
};

// RemoveFromCart
const removeFromCartRequest = () => {
  return {
    type: types.REMOVE_FROM_CART_REQUEST,
  };
};

const removeFromCartSuccess = (data) => {
  return {
    type: types.REMOVE_FROM_CART_SUCCESS,
    payload: data,
  };
};

const removeFromCartError = (error) => {
  return {
    type: types.REMOVE_FROM_CART_ERROR,
    error: error,
  };
};

// Create Order
const createOrderRequest = () => ({
  type: types.CREATE_ORDER_REQUEST,
});

const createOrderSuccess = (orderData) => ({
  type: types.CREATE_ORDER_SUCCESS,
  payload: orderData,
});

const createOrderError = () => ({
  type: types.CREATE_ORDER_ERROR,
});

// getOrderListRequest
const getOrderListRequest = () => ({
  type: types.GET_ORDER_LIST_REQUEST,
});

const getOrderListSuccess = (orderId) => ({
  type: types.GET_ORDER_LIST_SUCCESS,
  payload: orderId,
});

const getOrderListError = () => ({
  type: types.GET_ORDER_LIST_ERROR,
});

// GET_USER_PROFILE request action
const getUserProfileRequest = () => ({
  type: types.GET_USER_PROFILE_REQUEST,
});

// GET_USER_PROFILE success action
const getUserProfileSuccess = (data) => ({
  type: types.GET_USER_PROFILE_SUCCESS,
  payload: data,
});

// GET_USER_PROFILE error action
const getUserProfileError = (error) => ({
  type: types.GET_USER_PROFILE_ERROR,
  error,
});

// DELETE_ITEM_REQUEST from Cart
const deleteItemRequest = () => ({
  type: types.DELETE_ITEM_REQUEST,
});

const deleteItemSuccess = (removecartitem) => ({
  type: types.DELETE_ITEM_SUCCESS,
  payload: removecartitem,
});

const deleteItemError = (error) => ({
  type: types.DELETE_ITEM_ERROR,
  payload: error,
});

// Do Payment
const postPaymentRequest = () => ({
  type: types.POST_PAYMENT_REQUEST,
});

const postPaymentSuccess = (response) => ({
  type: types.POST_PAYMENT_SUCCESS,
  payload: response.data,
});

const postPaymentFailure = (error) => ({
  type: types.POST_PAYMENT_FAILURE,
  payload: error,
});

// getUserAddressByIdRequest
const getUserAddressByIdRequest = () => ({
  type: types.GET_USER_ADDRESS_BY_ID_REQUEST,
});

const getUserAddressByIdSuccess = (addressData) => ({
  type: types.GET_USER_ADDRESS_BY_ID_SUCCESS,
  payload: addressData,
});

const getUserAddressByIdError = () => ({
  type: types.GET_USER_ADDRESS_BY_ID_ERROR,
});

// AddAddress
const addAddressRequest = () => ({
  type: types.ADD_ADDRESS_REQUEST,
});

const addAddressSuccess = (addressData) => ({
  type: types.ADD_ADDRESS_SUCCESS,
  payload: addressData,
});

const addAddressFailure = (error) => ({
  type: types.ADD_ADDRESS_FAILURE,
  payload: error,
});

// fetchWishlistSuggestionsRequest
const fetchWishlistSuggestionsRequest = () => ({
  type: types.FETCH_WISHLIST_SUGGESTIONS_REQUEST,
});

const fetchWishlistSuggestionsSuccess = (data) => ({
  type: types.FETCH_WISHLIST_SUGGESTIONS_SUCCESS,
  payload: data,
});

const fetchWishlistSuggestionsError = (error) => ({
  type: types.FETCH_WISHLIST_SUGGESTIONS_ERROR,
  payload: error,
});

// send notify me request
const notifyMeRequest = () => ({
  type: types.SEND_NOTIFY_REQUEST,
});

const notifyMeSuccess = (data) => ({
  type: types.SEND_NOTIFY_SUCCESS,
  payload: data,
});

const notifyMeError = (error) => ({
  type: types.SEND_NOTIFY_ERROR,
  payload: error,
});

// check pin code availability
const checkPinCodeAvailabilityRequest = () => ({
  type: types.CHECK_PIN_CODE_AVAILABILITY_REQUEST,
});

const checkPinCodeAvailabilitySuccess = (data) => ({
  type: types.CHECK_PIN_CODE_AVAILABILITY_SUCCESS,
  payload: data,
});

const checkPinCodeAvailabilityError = (error) => ({
  type: types.CHECK_PIN_CODE_AVAILABILITY_ERROR,
  payload: error,
});
const emptyPinCodeAvailability = () => ({
  type: types.EMPTY_PIN_CODE_AVAILABILITY,
  payload: [],
});

// fetchAIGiftsRequest
const fetchAIGiftsRequest = () => ({
  type: types.FETCH_AIGIFTS_REQUEST,
});

const fetchAIGiftsSuccess = (data) => ({
  type: types.FETCH_AIGIFTS_SUCCESS,
  payload: data,
});

const fetchAIGiftsError = (error) => ({
  type: types.FETCH_AIGIFTS_ERROR,
  payload: error,
});

const getAllCategoryRequest = () => ({
  type: types.GET_ALL_CATEGORY_REQUEST,
});

const getAllCategorySuccess = (data) => ({
  type: types.GET_ALL_CATEGORY_SUCCESS,
  payload: data,
});

const getAllCategoryError = (error) => ({
  type: types.GET_ALL_CATEGORY_ERROR,
  payload: error,
});

// get all trending product
const getAllTrendingProductRequest = () => ({
  type: types.GET_ALL_TRENDING_PRODUCT_REQUEST,
});

const getAllTrendingProductSuccess = (data) => ({
  type: types.GET_ALL_TRENDING_PRODUCT_SUCCESS,
  payload: data,
});

const getAllTrendingProductError = (error) => ({
  type: types.GET_ALL_TRENDING_PRODUCT_ERROR,
  payload: error,
});

// get all trending product
const getAllWishlistProductRequest = () => ({
  type: types.GET_ALL_WISHLIST_PRODUCT_REQUEST,
});

const getAllWishlistProductSuccess = (data) => ({
  type: types.GET_ALL_WISHLIST_PRODUCT_SUCCESS,
  payload: data,
});

const getAllWishlistProductError = (error) => ({
  type: types.GET_ALL_WISHLIST_PRODUCT_ERROR,
  payload: error,
});

const getSubCategoryRequest = () => ({
  type: types.GET_SUBCATEGORY_REQUEST,
});

const getSubCategorySuccess = (data) => ({
  type: types.GET_SUBCATEGORY_SUCCESS,
  payload: data,
});

const getSubCategoryError = (error) => ({
  type: types.GET_SUBCATEGORY_ERROR,
  payload: error,
});

// Sub Category plants
const getPlantsSubCategoryRequest = () => {
  return {
    type: types.GET_SUB_CATEGORY_PLANTS_REQUEST,
  };
};

const getPlantsSubCategorySuccess = (payload) => {
  return {
    type: types.GET_SUB_CATEGORY_PLANTS_SUCCESS,
    payload,
  };
};

const getPlantsSubCategoryError = () => {
  return {
    type: types.GET_SUB_CATEGORY_PLANTS_ERROR,
  };
};

// --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

// getSingleProduct
const getSingleProduct = (productId) => (dispatch) => {
  dispatch(getSingleProductRequest());
  axios
    .get(`${BASE_URL_FLORAHUB}/inventory/api/v1/product?productId=${productId}`)
    .then((response) => {
      dispatch(getSingleProductSuccess(response.data?.payload));
    })
    .catch((e) => {
      dispatch(getSingleProductError());
    });
};

// fetchSimilarProducts
const fetchSimilarProducts = (productId) => async (dispatch) => {
  dispatch(getSimilarProductsRequest());
  try {
    const response = await axios.get(
      `${BASE_URL_FLORAHUB}/inventory/api/v2/product/SimilarProducts?productId=${productId}&page=0&size=10`
    );
    // const similarProducts = t;
    dispatch(getSimilarProductSuccess(response.data.payload.content));
  } catch (error) {
    dispatch(getSimilarProductError(error));
  }
};

// fetchFrequentlyBoughtTogether
const fetchFrequentlyBoughtTogether = (productId) => async (dispatch) => {
  dispatch(getFrequentlyBoughtTogetherRequest());
  try {
    const response = await axios.get(
      `${BASE_URL_FLORAHUB}/inventory/api/v2/product/all/bought-together?productId=${productId}&page=0&size=10`
    );
    dispatch(getFrequentlyBoughtTogetherSuccess(response.data.payload.content));
  } catch (error) {
    dispatch(getFrequentlyBoughtTogetherError(error));
  }
};

// addToCart
const addToCart = (cartData) => {
  return (dispatch) => {
    dispatch(addToCartRequest());
    axios
      .post(`${BASE_URL_FLORAHUB}/inventory/api/v1/cart`, cartData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        dispatch(addToCartSuccess(response.data));
      })
      .catch((error) => {
        dispatch(addToCartError(error));
      });
  };
};

// GetCart
const getCart = () => (dispatch) => {
  dispatch(getCartRequest());
  axios
    .get(`${BASE_URL_FLORAHUB}/inventory/api/v1/cart`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      const payload = response.data?.payload;
      dispatch(getCartSuccess(payload));
    })
    .catch((error) => {
      dispatch(getCartError(error));
    });
};

// getOrderList
const fetchOrderList = (orderId) => (dispatch) => {
  dispatch(getOrderListRequest());
  axios
    .get(
      `${BASE_URL_FLORAHUB}/order/api/v1/order?orderId=${orderIdFromLocal}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      const orderList = response.data?.payload || [];
      dispatch(getOrderListSuccess(orderList));
    })
    .catch(() => {
      dispatch(getOrderListError());
    });
};

const getUserProfile = (accessToken) => (dispatch) => {
  dispatch(getUserProfileRequest());
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  axios
    .get(`${BASE_URL_USER}/api/v1/user/get-profile`, { headers })
    .then((response) => {
      dispatch(getUserProfileSuccess(response.data.payload));
    })
    .catch((error) => {
      dispatch(getUserProfileError(error));
    });
};

const storeOrderIdInLocalStorage = (orderId) => {
  localStorage.setItem("orderId", orderId);
};

const createOrder = (orderData) => (dispatch) => {
  dispatch(createOrderRequest());
  axios
    .post(`${BASE_URL_FLORAHUB}/order/api/v1/order`, orderData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      const orderId = response.data.payload.orderId;
      storeOrderIdInLocalStorage(orderId);
    })
    .catch((error) => {
      dispatch(createOrderError());
    });
};

// DELETE_ITEM_REQUEST from Cart
const deleteCartItems = (removecartitem) => (dispatch) => {
  dispatch(deleteItemRequest());
  axios
    .put(`${BASE_URL_FLORAHUB}/inventory/api/v1/cart`, removecartitem, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      dispatch(deleteItemSuccess(response.data));
      dispatch(getCart());
    })
    .catch((error) => {
      dispatch(deleteItemError(error));
    });
};

// Do Payment
const doPayment = (requestData) => {
  return async (dispatch) => {
    dispatch(postPaymentRequest());
    try {
      const response = await axios.post(
        `${BASE_URL_PAYMENT}/api/v1/do`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(postPaymentSuccess(response));
    } catch (error) {
      dispatch(postPaymentFailure(error));
    }
  };
};

// getOrderByIdRequest
const getOrderByIdRequest = () => ({
  type: types.GET_ORDER_BY_ID_REQUEST,
});

export const getOrderByIdSuccess = (orderData) => ({
  type: types.GET_ORDER_BY_ID_SUCCESS,
  payload: orderData,
});

export const getOrderByIdError = (error) => ({
  type: types.GET_ORDER_BY_ID_ERROR,
  payload: error,
});

// const getOrderById = (orderId) => {
//   return async (dispatch) => {
//     dispatch(getOrderByIdRequest());
//     try {
//       const response = await axios.get(
//         `${BASE_URL_FLORAHUB}/order/api/v1/order/getOrderByOrderId?orderId=${orderIdFromLocal}`,
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//           },
//         },
//       );
//       dispatch(getOrderByIdSuccess(response.data));
//     } catch (error) {
//       dispatch(getOrderByIdError(error));
//     }
//   };
// };

const getOrderById = (OrderId) => (dispatch) => {
  dispatch(getOrderByIdRequest());
  axios
    .get(
      `${BASE_URL_FLORAHUB}/order/api/v1/order/getOrderByOrderId?orderId=${OrderId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      dispatch(getOrderByIdSuccess(response.data.payload));
    })
    .catch((error) => {
      dispatch(getOrderByIdError(error));
    });
};

// getUserAddressById
const getUserAddressById = (addressId) => (dispatch) => {
  dispatch(getUserAddressByIdRequest());

  axios
    .get(`${BASE_URL_USER}/api/v1/user/addressId?addressId=${addressId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      const addressData = response.data?.payload;
      dispatch(getUserAddressByIdSuccess(addressData));
    })
    .catch((error) => {
      dispatch(getUserAddressByIdError());
    });
};

const updateIsInCart = (isInCart) => ({
  type: types.UPDATE_IS_IN_CART,
  payload: isInCart,
});

const fetchLatestCart = () => ({
  type: types.FETCH_LATEST_CART,
});

const fetchSuggestedProducts = (productId) => (dispatch) => {
  dispatch(getSuggestedProductsRequest());
  axios
    .get(
      `${BASE_URL_FLORAHUB}/inventory/api/v1/product/SuggestedProducts?productId=${productId}&page=0&size=10`
    )
    .then((response) => {
      const payload = response.data.payload.content;
      dispatch(getSuggestedProductsSuccess(payload));
    })
    .catch((error) => {
      dispatch(getSuggestedProductsError(error));
    });
};

const addAddress = (formData) => {
  return async (dispatch) => {
    try {
      dispatch(addAddressRequest());
      const response = await axios.post(
        `${BASE_URL_USER}/api/v1/user/add-address`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(addAddressSuccess(response.data));
    } catch (error) {
      dispatch(addAddressFailure(error));
    }
  };
};

const fetchWishlistSuggestions = (formData) => {
  return (dispatch) => {
    dispatch(fetchWishlistSuggestionsRequest());
    axios
      .post(`${BASE_URL_WISHLIST}/suggestions`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        dispatch(fetchWishlistSuggestionsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchWishlistSuggestionsError(error.message));
      });
  };
};

const getNotifyMe = (productId) => {
  return (dispatch) => {
    dispatch(notifyMeRequest());
    axios
      .post(
        `${BASE_URL_FLORAHUB}/order/public-api/v2/notify-me`,
        { productId: productId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((response) => {
        dispatch(notifyMeSuccess(response.data));
      })
      .catch((error) => {
        dispatch(notifyMeError(error.message));
      });
  };
};

// Check pinCode availability
const checkPinCodeAvailability = (pinCode) => {
  return (dispatch) => {
    dispatch(checkPinCodeAvailabilityRequest());

    axios
      .get(
        `${BASE_URL_FLORAHUB}/order/api/v1/order/getDeliveryStatus?pincode=${pinCode}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((response) => {
        dispatch(checkPinCodeAvailabilitySuccess(response.data.payload));
      })
      .catch((error) => {
        dispatch(checkPinCodeAvailabilityError(error));
      });
  };
};

const fetchAIGifts = (currentPage) => {
  return (dispatch) => {
    dispatch(fetchAIGiftsRequest());

    axios
      .get(`${BASE_URL_WISHLIST}/getaigifts?page=${currentPage}&size=5`, {
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        dispatch(fetchAIGiftsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchAIGiftsError(error));
      });
  };
};

const getAllCategory = () => async (dispatch) => {
  dispatch(getAllCategoryRequest());

  try {
    const response = await axios.get(
      `${BASE_URL_MEDIA}/config/categories/all?screenTypes=DASHBOARD`,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (response.status === 200) {
      dispatch(getAllCategorySuccess(response.data));
    }
  } catch (error) {
    dispatch(getAllCategoryError(error));
  }
};

// Get all trending products
const getAllTrendingProduct = () => async (dispatch) => {
  dispatch(getAllTrendingProductRequest());

  try {
    const response = await axios.get(
      `${BASE_URL_FLORAHUB}/inventory/api/v1/product/trendingProducts?page=0&size=30`,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (response.status === 200) {
      dispatch(getAllTrendingProductSuccess(response.data.payload.content));
    }
  } catch (error) {
    dispatch(getAllTrendingProductError(error));
  }
};
// Get all wishlist products
const getAllWishlistProduct = async (dispatch) => {
  dispatch(getAllWishlistProductRequest());

  try {
    const response = await axios.get(
      `${BASE_URL_FLORAHUB}/inventory/api/v1/wislist/getAllWishlistProduct`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (response.status === 200) {
      dispatch(getAllWishlistProductSuccess(response.data.payload));
    }
  } catch (error) {
    dispatch(getAllWishlistProductError(error));
  }
};

const fetchSubCategoryData = (catId, name) => async (dispatch) => {
  dispatch(getSubCategoryRequest());

  try {
    const response = await axios.get(
      `${BASE_URL_MEDIA}/media/file/admin/get/bycategoryIdSubCategoryId?categoryId=${catId}&subCategoryId=${name}`,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`, // Replace with your actual token or authentication mechanism
        },
      }
    );

    if (response.status === 200) {
      dispatch(getSubCategorySuccess(response.data));
    }
  } catch (error) {
    dispatch(getSubCategoryError(error));
  }
};

// get plants by sub-category
const getPlantsSubCategory = (plantCategory) => (dispatch) => {
  dispatch(getPlantsSubCategoryRequest());
  return axios
    .get(
      `${BASE_URL_FLORAHUB}/inventory/api/v1/product/getAllSubCategory?category=plants&subCategory=${plantCategory}&page=0&size=100`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    .then((response) => {
      return dispatch(
        getPlantsSubCategorySuccess(response.data.payload.content)
      );
    })
    .catch((e) => {
      dispatch(getPlantsSubCategoryError());
    });
};

export {
  getSingleProduct,
  addToCart,
  updateQuantity,
  getCart,
  doPayment,
  fetchSimilarProducts,
  fetchFrequentlyBoughtTogether,
  deleteCartItems,
  createOrder,
  fetchOrderList,
  getUserProfile,
  getOrderById,
  getUserAddressById,
  updateCart,
  updateIsInCart,
  fetchLatestCart,
  fetchSuggestedProducts,
  addAddress,
  fetchWishlistSuggestions,
  fetchAIGifts,
  getAllCategory,
  fetchSubCategoryData,
  getNotifyMe,
  getPlantsSubCategory,
  checkPinCodeAvailability,
  emptyPinCodeAvailability,
  getAllTrendingProduct,
  getAllWishlistProduct,
};
